export default "__VITE_ASSET__gw4NFNDA__"